import {
  useDetailQuizzes,
  useListQuizzes,
} from '@/core/domain/crm/Quizzes/Quizzes.hooks';
import { useDebounce } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Select, SelectProps } from 'antd';
import { useState } from 'react';

const QuizzesSelect: React.FC<SelectProps> = (props) => {
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const { data: quizzesData, isLoading } = useListQuizzes({
    description: search,
    rows: 30,
  });
  const dataItems = flatInfiniteData(quizzesData);

  const { data: detail } = useDetailQuizzes(props.value);

  const options =
    detail && !dataItems?.find((item) => item.id === detail.id)
      ? [...(dataItems || []), detail]
      : dataItems;

  return (
    <Select
      {...props}
      loading={isLoading}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      allowClear
      options={options?.map((item) => ({
        value: item.id,
        label: item.description,
      }))}
    />
  );
};

export default QuizzesSelect;
